import { Link } from 'react-router';
import { motion } from 'motion/react';
import { Mascot, spring } from '@redpandev/ui';
import { AmbientBackdrop } from '../components/hub/AmbientBackdrop';
import { pillPrimary } from '../components/hub/linkStyles';

export function NotFoundPage() {
  return (
    <main className="relative overflow-hidden">
      <AmbientBackdrop />
      <div className="relative mx-auto flex min-h-[70vh] max-w-xl flex-col items-center justify-center px-6 py-16 text-center">
        <motion.div
          initial={{ scale: 0.6, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={spring.soft}
        >
          <Mascot mood="thinking" size={180} aria-label="Redpan se demande où tu es passé" />
        </motion.div>
        <h1 className="mt-6 font-display text-4xl font-bold text-ink-100 sm:text-5xl">
          404&nbsp;— Tu t'es perdu dans le bambou&nbsp;?
        </h1>
        <p className="mt-3 text-ink-400">
          Cette page n'existe pas… ou alors Redpan l'a soigneusement cachée.
        </p>
        <Link to="/" className={`${pillPrimary} mt-8`}>
          Retour au hub
        </Link>
      </div>
    </main>
  );
}
